// extracted by mini-css-extract-plugin
export default {"App":"_FAQs_App__AFtDf","faqs":"_FAQs_faqs__N8sbk","wrapper":"_FAQs_wrapper__xaez1"};